import {ApiResponse} from "../models/ApiResponse";
import MainBackendAxios from "../utils/MainBackendAxios";
import {FunctionsHelper} from "../utils/FunctionsHelper";
import {Role} from "../models/Role";

export const RoleService = {
    getAll: async (): Promise<ApiResponse<Role[]>> => {
        try {
            const response = await MainBackendAxios.get(`/role/get-all`);

            return {
                success: true,
                status: response.status,
                data: response?.data?.data,
            };
        } catch (err: any) {
            return FunctionsHelper.getErrorFormat(err);
        }
    },
};
